import { CustomsField } from '../customs-field';
import { CountryDropdown } from './origin-country-dropdown';
import { messages } from '../messages';

type CustomsCountryOfOriginProps = {
  onChange: (countryCode: string) => void;
  selectedCountryCode?: string;
};

export const CustomsCountryOfOrigin = ({ onChange, selectedCountryCode = '' }: CustomsCountryOfOriginProps) => (
  <CustomsField label={messages.countryOfOriginLabel} required>
    <CountryDropdown onChange={onChange} selectedCountryCode={selectedCountryCode} />
  </CustomsField>
);
